// src/plugins/vuetify.js
import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/styles';
import { en } from 'vuetify/locale';
import { createVuetify } from 'vuetify';
import { VDateInput } from 'vuetify/labs/VDateInput';
import { VCalendar } from 'vuetify/labs/VCalendar';
import { VTimePicker } from 'vuetify/labs/VTimePicker';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';

export default createVuetify({
  components: {
    ...components,
    VDateInput,
    VCalendar,
    VTimePicker,
  },
  directives,
  theme: {
    defaultTheme: 'light',
    themes: {
      light: {
        colors: {
          primary: '#2C74B3',
          secondary: '#205295',
          third: '#144272',
          fourth: '#0A2647',
          accent: '#292E1E',
        },
      },
    },
  },
  locale: {
    locale: 'en-CA',
    messages: { 'en-CA': en },
  },
  // CORRECTED defaults section
  defaults: {
    // Other defaults...
    VTextField: { autocomplete: 'off' },
    VCombobox: { autocomplete: 'off' },
    VTextarea: { autocomplete: 'off' },
    VSelect: { autocomplete: 'off' },
    VAutocomplete: { autocomplete: 'off' },

    // VTooltip defaults go HERE, inside the main defaults object
    VTooltip: {
      disabled: true, // Disable all v-tooltips by default
    },
  },
});
